import { BehaviorSubject } from "rxjs";
import FastStorage from "./FastStorage";

type PersistConfig = {
  sensitiveKeys?: string[];
};

class PersistStorage {
  keyName: string;
  observer: BehaviorSubject<any>;
  config: PersistConfig;

  constructor(
    keyName: string,
    observer: BehaviorSubject<any>,
    config: PersistConfig = {}
  ) {
    this.keyName = keyName;
    this.observer = observer;
    this.config = config;
  }

  private filterSensitiveData(data: any): any {
    if (!data || typeof data !== "object") return data;

    // For other data, filter out sensitive keys if specified
    if (this.config.sensitiveKeys?.length) {
      const filtered = { ...data };
      this.config.sensitiveKeys.forEach((key) => delete filtered[key]);
      return filtered;
    }

    return data;
  }

  init = async () => {
    const lastDataString = await FastStorage.getItem(this.keyName);

    if (lastDataString) {
      const parsedData = JSON.parse(lastDataString);
      this.observer.next(parsedData);
    }

    this.observer.subscribe((next) => {
      const filteredData = this.filterSensitiveData(next);
      FastStorage.setItem(this.keyName, JSON.stringify(filteredData));
    });
  };
}

export default PersistStorage;
